import Index from '../components/case/Index'
import CaseManager from '../components/case/caseManager/CaseManager'
import CaseDetail from '../components/case/caseManager/caseDetail/CaseDetail'
export default [
  {
    path: '/index',
    name: 'Index',
    redirect: 'manager',
    component: Index,
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '/manager',
        name: 'CaseManager',
        meta: {
          title: '病例管理'
        },
        component: CaseManager
      },
      {
        path: 'detail/:caseid',
        name: 'CaseDetail',
        meta: {
          title: '病例详情'
        },
        component: CaseDetail
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/caseManager.js